export const JANE_APP_URL = "https://thrivebahamas.janeapp.com";

export const TAGLINE = "Embodying what it means to thrive";

export const WHATSAPP = {
  url: "https://wa.me/12428040010?text=Hello%20Thrive!%20I%20have%20a%20question%20about%20therapy%20for%20my%20child.",
  display: "+1 (242) 804-0010",
};

export const CONTACT_INFO = {
  location: "11 Mount Royal Ave (Hawkins Hill), Nassau, The Bahamas",
  email: "info@thrivebahamas.com",
  phone: "+1 (242) 804-0010",
  hours: "By appointment only",
};

export const INSTAGRAM_URL = "https://instagram.com/thrivebahamas";

export const MAPS_LINK =
  "https://www.google.com/maps/search/?api=1&query=11+Mount+Royal+Ave+Nassau+The+Bahamas";
export const MAPS_EMBED_URL =
  "https://maps.google.com/maps?q=11%20Mount%20Royal%20Ave%2C%20Nassau%2C%20The%20Bahamas&z=15&output=embed";

export const SERVICES = [
  {
    slug: "physiotherapy",
    name: "Physiotherapy",
    fullName: "Pediatric Physiotherapy",
    tagline: "Little bodies. Big milestones.",
    icon: "Baby",
    color: "teal",
    image: "/thrive-pt.jpg",
    portrait: true,
    description:
      "Helping children build strength, coordination and confidence in the way they move - from first steps to return-to-sport.",
    seoTitle: "Pediatric Physiotherapy in Nassau & The Bahamas | Thrive",
    seoDescription:
      "Pediatric physiotherapy in Nassau, Bahamas for children aged 0-18. Support for developmental delays, torticollis, injuries, gait and gross motor skills. Book an evaluation at Thrive.",
    heroTitle: "Pediatric Physiotherapy",
    heroText:
      "Pediatric Physiotherapy helps children build the strength, balance, coordination and movement skills they need to explore, play and participate confidently in everyday life. From infancy through adolescence, we support children with developmental, neurological and orthopedic needs through individualized, age-appropriate treatment. Using movement, play and purposeful activities, we help children develop meaningful skills while equipping families with practical strategies to support progress beyond the therapy room.",
    reasons: [
      "Delayed gross motor milestones like sitting, crawling or walking",
      "Recovery after surgery or an injury at birth or early childhood",
      "Torticollis and/or head flattening",
      "Toe walking or an unusual walking pattern",
      "Poor balance, coordination or frequent falls",
      "Posture concerns or low muscle tone",
    ],
    signs: [
      "Misses motor milestones compared to other children their age",
      "Trips, stumbles or falls more often than expected",
      "Avoids running, climbing or physical play",
      "A baby who strongly prefers looking to one side",
      "Tires quickly during everyday activities",
      "Complains of pain during movement or sport",
    ],
    evaluation: [
      { title: "We listen first", text: "We talk through your concerns, your child's history and what you hope therapy will achieve." },
      { title: "We play and assess", text: "Your child moves, plays and explores while we gently assess strength, movement and motor skills." },
      { title: "We plan together", text: "You leave with a clear picture of how your child is doing and a plan for the road ahead." },
    ],
    faqs: [
      { q: "What ages do you see for physiotherapy?", a: "From newborns right through to 18 years. Early intervention is our specialty!" },
      { q: "Will sessions hurt or upset my child?", a: "Sessions are play-based and always move at your child's pace. We never force movements - we build trust first, then skills." },
      { q: "How many sessions will my child need?", a: "Every child is different. After the initial evaluation we'll share an honest recommendation and review progress together as we go." },
    ],
  },
  {
    slug: "occupational-therapy",
    name: "Occupational Therapy",
    fullName: "Pediatric Occupational Therapy",
    tagline: "Skills for play, learning & life.",
    icon: "Hand",
    color: "leaf",
    image: "/thrive-ot.webp",
    description:
      "Supporting children in the 'jobs' of childhood - playing, learning, writing, dressing and caring for themselves.",
    seoTitle: "Pediatric Occupational Therapy in Nassau & The Bahamas | Thrive",
    seoDescription:
      "Pediatric occupational therapy in Nassau, Bahamas. Help with fine motor skills, handwriting, sensory processing, self-care and emotional regulation for children 0-18.",
    heroTitle: "Pediatric Occupational Therapy",
    heroText:
      "Pediatric Occupational Therapy helps children develop the skills they need to participate more independently and confidently in everyday life. We support fine motor and visual motor skills, self-care, sensory processing, attention, regulation, play and school participation. Through practical, playful and individualized therapy, we consider the whole child and the activities that matter most, helping build meaningful skills and giving families strategies that support greater independence at home, school and in the community.",
    reasons: [
      "Handwriting or pencil grip struggles",
      "Difficulty with buttons, zippers, cutlery or dressing",
      "Sensory sensitivities to sounds, touch or clothing",
      "Fine motor delays - scissors, blocks, small toys",
      "Trouble with attention, focus or emotional regulation",
      "School readiness concerns raised by teachers",
    ],
    signs: [
      "Avoids or melts down during everyday tasks",
      "Struggles to keep up with handwriting at school",
      "Seems overwhelmed by busy or noisy environments",
      "Clumsy with small objects compared to peers",
      "Needs far more help with self-care than expected for their age",
      "Big reactions to small changes in routine",
    ],
    evaluation: [
      { title: "We listen first", text: "We chat about your child's daily routines, strengths and the tasks that feel tricky right now." },
      { title: "We play and assess", text: "Through games and hands-on activities, we explore fine motor, sensory and self-care skills." },
      { title: "We plan together", text: "You'll get practical strategies for home and school, plus a therapy plan if it's needed." },
    ],
    faqs: [
      { q: "Is occupational therapy about jobs?", a: "Not for kids! A child's occupations are playing, learning and self-care. OT helps children take part in those everyday activities with confidence." },
      { q: "Can you help with handwriting?", a: "Yes - handwriting is one of the most common reasons families see us. We work on grip, letter formation, spacing and endurance, all through engaging activities." },
      { q: "My child is very sensitive to textures and noise. Can OT help?", a: "Absolutely. Sensory processing is a core part of occupational therapy. We help children feel more comfortable and regulated in their world." },
    ],
  },
  {
    slug: "speech-language-therapy",
    name: "Speech and Language",
    fullName: "Pediatric Speech and Language Therapy",
    tagline: "More than words. It's connection.",
    icon: "MessageCircle",
    color: "lilac",
    image: "/thrive-speech.webp",
    description:
      "Helping children understand language, express themselves and connect with the people around them.",
    seoTitle: "Pediatric Speech and Language Therapy in Nassau & The Bahamas | Thrive",
    seoDescription:
      "Speech and language therapy in Nassau, Bahamas for late talkers, unclear speech, stuttering and language delays. Play-based sessions for children 0-18 at Thrive.",
    heroTitle: "Pediatric Speech and Language Therapy",
    heroText:
      "Pediatric Speech & Language Therapy helps children develop the communication skills they need to connect, express themselves and engage with the world around them. We support speech, language, early communication, fluency, social communication and alternative and augmentative communication (AAC). Through engaging, individualized and age-appropriate therapy, we help children strengthen meaningful communication while working closely with families to build these skills into everyday routines and help every child find their voice.",
    reasons: [
      "A toddler who isn't talking as expected",
      "Speech that's difficult for others to understand",
      "A limited vocabulary for their age",
      "Difficulty understanding or following instructions",
      "Stuttering or getting stuck on words",
      "Challenges with social communication",
    ],
    signs: [
      "Fewer words than other children the same age",
      "Becomes frustrated when trying to communicate",
      "Strangers struggle to understand them after age 3",
      "Doesn't respond consistently to their name or simple directions",
      "Repeats sounds or words, or gets 'stuck' when speaking",
      "Relies on gestures more than words",
    ],
    evaluation: [
      { title: "We listen first", text: "You know your child's communication best - we start with your observations, history and worries." },
      { title: "We play and assess", text: "Through books, toys and conversation, we gently assess speech sounds, language and understanding." },
      { title: "We plan together", text: "You'll leave knowing where your child is, what to encourage at home and how therapy can help." },
    ],
    faqs: [
      { q: "When should my child be talking?", a: "Most children say first words around 12 months and join two words by age 2. Every child is different, but if you're worried, an evaluation gives you clear answers rather than 'wait and see'." },
      { q: "We speak two languages at home. Is that a problem?", a: "Not at all - bilingualism does not cause speech or language delays. We support families in the languages that matter most to them." },
      { q: "Do you work with children who stutter?", a: "Yes. We help children develop smoother, more confident speech and support parents with strategies that take the pressure off." },
    ],
  },
  {
    slug: "feeding-therapy",
    name: "Feeding Therapy",
    fullName: "Pediatric Feeding Therapy",
    tagline: "Making every bite count.",
    icon: "Apple",
    color: "sunny",
    image: "/thrive-feeding.webp",
    description:
      "Turning stressful mealtimes into positive experiences - helping children explore food and enjoy eating.",
    seoTitle: "Pediatric Feeding Therapy in Nassau & The Bahamas | Thrive",
    seoDescription:
      "Pediatric feeding therapy in Nassau, Bahamas. Gentle help for picky eating, food aversions, texture transitions and stressful mealtimes. Book an evaluation at Thrive.",
    heroTitle: "Pediatric Feeding Therapy",
    heroText:
      "Pediatric Feeding Therapy is a specialty service at Thrive, provided by Physiotherapy and Speech & Language Therapy team members with additional training in pediatric feeding. We support children with challenges related to eating, drinking, food variety, textures, oral motor skills, chewing, swallowing and sensory sensitivities. Using a responsive, child-centered approach, we work alongside families to build feeding skills, confidence and positive experiences while making mealtimes safer, more comfortable and more enjoyable.",
    reasons: [
      "A very limited list of accepted foods",
      "Gagging or distress with new textures",
      "Mealtimes that regularly end in tears or battles",
      "Slow or difficult transition to solids",
      "Concerns about growth or nutrition",
      "Trouble moving from bottle or breast to cup",
    ],
    signs: [
      "Eats fewer than 20 different foods",
      "Refuses entire food groups or textures",
      "Takes a very long time to finish meals",
      "Becomes upset when new food is simply on the plate",
      "Still relies heavily on milk, purées or bottles past infancy",
      "Mealtimes feel stressful for the whole family",
    ],
    evaluation: [
      { title: "We listen first", text: "We talk through your child's eating history, favourite foods and what mealtimes look like at home." },
      { title: "We explore together", text: "With no pressure and plenty of play, we observe how your child responds to different foods and textures." },
      { title: "We plan together", text: "You'll get practical mealtime strategies and a gentle, step-by-step plan for expanding your child's diet." },
    ],
    faqs: [
      { q: "Isn't picky eating just a phase?", a: "Often it is - but when the list of accepted foods keeps shrinking, or mealtimes cause daily stress, a little support goes a long way. An evaluation can tell you which it is." },
      { q: "Will you make my child eat?", a: "Never. Pressure backfires. We use gentle, play-based exploration so children discover new foods at their own pace." },
      { q: "Do parents join feeding sessions?", a: "Yes - parents are essential. We coach you through the same strategies we use, so progress continues at every meal at home." },
    ],
  },
];

export const CONCERNS = [
  { id: "not-talking", label: "My child isn't talking yet or isn't using as many words as expected", service: "speech-language-therapy", reason: "Speech & language therapy helps children find their words - building vocabulary, sentences and the confidence to use them, all through play." },
  { id: "weak-tires", label: "My child seems weak or tires easily", service: "physiotherapy", reason: "Physiotherapy builds strength, stamina and coordination gently, so everyday play stops feeling like hard work." },
  { id: "picky-eater", label: "My child is a very picky or selective eater", service: "feeding-therapy", reason: "Feeding therapy helps selective eaters become curious about food, one tiny, pressure-free step at a time." },
  { id: "fine-motor", label: "My child has difficulty with fine motor skills", service: "occupational-therapy", reason: "Occupational therapy strengthens the little-hand skills behind drawing, building, buttons and zips - through games kids love." },
  { id: "not-walking", label: "My child isn't walking yet or walks on their toes", service: "physiotherapy", reason: "Physiotherapy supports the strength, balance and movement patterns behind confident first steps and steady walking." },
  { id: "hard-to-understand", label: "My child is difficult for others to understand", service: "speech-language-therapy", reason: "Speech & language therapy helps children pronounce sounds clearly, so the people around them can understand every word." },
  { id: "slow-eater", label: "My child takes an unusually long time to eat", service: "feeding-therapy", reason: "Feeding therapy looks at how your child chews, manages textures and approaches mealtimes - then makes eating easier and more enjoyable." },
  { id: "sensory-overwhelm", label: "My child avoids or becomes overwhelmed by certain textures, sounds, movement or environments", service: "occupational-therapy", reason: "Occupational therapy helps children feel comfortable with sensory input, so busy, noisy or touchy moments become manageable." },
  { id: "head-shape", label: "I'm concerned about my child's head shape", service: "physiotherapy", reason: "Physiotherapy gently addresses head-shape and neck preferences in babies - early, simple support makes a big difference." },
  { id: "social-communication", label: "My child has difficulty communicating socially with others", service: "speech-language-therapy", reason: "Speech & language therapy builds the back-and-forth skills of conversation - sharing, turn-taking and connecting with others." },
  { id: "self-care", label: "My child has difficulty dressing, using utensils or completing other self-care tasks", service: "occupational-therapy", reason: "Occupational therapy turns daily tasks like dressing and using cutlery into achievable, confidence-building wins." },
  { id: "cough-gag-choke", label: "My child coughs, gags or frequently chokes while eating or drinking", service: "feeding-therapy", reason: "Feeding therapy carefully looks at how your child manages food and drink, and builds safer, more comfortable mealtimes." },
  { id: "several-unsure", label: "I'm concerned about several areas / I'm not sure", service: "unsure", reason: "" },
];

export const INSURANCE_FAQ = [
  { q: "Can I use my insurance at Thrive?", a: "Many families do. Coverage for pediatric therapy varies between plans, so the first step is to share your insurance details with us before your appointment. We'll help you understand how your plan may apply." },
  { q: "Do I need a referral for insurance?", a: "Some insurance plans require a physician's referral before therapy sessions can be covered, while others don't. Check your policy documents - or simply ask us and we'll help you figure out what your plan needs." },
  { q: "Will you check my benefits?", a: "Yes. As a courtesy, our team can help verify your benefits before your first visit so you have a clearer picture of what to expect. Sharing your insurance information as early as possible makes this easy." },
  { q: "What might I need to pay?", a: "Depending on your plan, there may be a copay, deductible or patient-responsibility amount, and any portion not covered by insurance remains the family's responsibility. We'll always be transparent about fees before sessions begin - no surprises." },
  { q: "What if I don't have coverage?", a: "Self-pay options are available and we're happy to talk them through with you. We also provide detailed receipts that you can submit to your insurer if your plan offers any reimbursement." },
  { q: "What should I provide before our appointment?", a: "Please have your insurance card, the policyholder's details, your child's information and any referral documents ready. Sending these ahead of time means your first visit can focus entirely on your child." },
];

export const INSURERS = [
  { name: "Colina", logo: "/insurers/colina.png" },
  { name: "CG Atlantic", logo: "/insurers/cg-atlantic.svg" },
  { name: "BahamaHealth", logo: "/insurers/bahamahealth.png" },
  { name: "BAF Financial & Insurance", logo: "/insurers/baf.png" },
];

export const FOUNDER_BIO = [
  "Holly Sands is a pediatric physiotherapist, Certified Pediatric Feeding Therapist, and the founder of Thrive, but at the heart of everything she does is a genuine belief in the potential of children and the power of giving families the right support at the right time.",
  "A graduate of the University of Richmond, Holly went on to complete her postgraduate physiotherapy training at Manchester Metropolitan University in the United Kingdom. Her clinical passion lies in developmental physiotherapy, early intervention and infant development, with a particular love for working with children during the remarkable first three years of life.",
  "Holly is known for bringing both clinical intention and genuine connection into therapy. Her approach is child-led, responsive and grounded in evidence, with plenty of room for play, personality and meeting children exactly where they are. With parents, she is candid and compassionate, believing families deserve not only excellent therapy, but clear answers, practical tools, plans, and the confidence to advocate for and support their child beyond the clinic.",
  "That same energy follows Holly outside of Thrive. She loves movement, the ocean, travelling and the luxury of a good quiet afternoon. But one of her favourite titles will always be Auntie Holly, a role that perhaps says as much about her love for children as any credential ever could.",
  "Holly is ambitious about what pediatric care can look like in The Bahamas, but her measure of success remains beautifully simple: children making meaningful progress and families leaving more empowered, equipped and encouraged than when they arrived.",
];

export const TEAM = [
  {
    name: "Holly Sands",
    role: "Founder & Pediatric Physiotherapist",
    credentials: "MPT",
    registrations: ["Bahamas Health Professions Council #12.132"],
    email: "info@thrivebahamas.com",
    discipline: "physiotherapy",
    initials: "HS",
    color: "bg-teal",
  },
  {
    name: "Jordan Moxey",
    role: "Occupational Therapist",
    credentials: "MS OT",
    registrations: ["Bahamas Health Professions Council #9.028"],
    email: "jordan@thrivebahamas.com",
    photo: "/jordan-moxey.png",
    discipline: "occupational-therapy",
    initials: "JM",
    color: "bg-leaf",
  },
  {
    name: "Tayla-Ann Macaskill",
    role: "Speech & Language Pathologist",
    credentials: "MA SLP",
    registrations: [
      "Bahamas Health Professions Council #2.032",
      "Health Professions Council of South Africa #0017922",
    ],
    email: "tayla@thrivebahamas.com",
    photo: "/tayla-macaskill.png",
    photoPos: "center 62%",
    discipline: "speech-language-therapy",
    initials: "TM",
    color: "bg-lilac",
  },
];

export const FEATURED_TESTIMONIALS = [
  {
    quote:
      "Thrive has had an incredible impact on my child's life. Holly's patience, dedication and positive attitude not only helped my child thrive, but also eased my fears about his future. I gained confidence and hope as a parent. I always felt informed, supported and like we were never facing the journey alone.",
    author: "Legend's Parent",
    service: "Physiotherapy & Occupational Therapy",
    accent: "teal",
  },
  {
    quote:
      "My child progressed tremendously with his handwriting, self-care, feeding and independence. He is now better able to manage sensory triggers, and I feel much more comfortable allowing him to explore different environments. Most importantly, he loved going to therapy. He felt safe and genuinely cared for, which mattered so much to me.",
    author: "Thrive Parent",
    service: "Occupational Therapy",
    accent: "leaf",
  },
  {
    quote:
      "Thrive provided such a supportive and welcoming environment for my daughter. Holly was incredibly patient, caring and professional. She took her time, listened attentively and made us feel heard and supported. I especially appreciated the personal attention and genuine care she showed during every session.",
    author: "Alissa's Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
  {
    quote:
      "Thrive helped teach me how to safely stretch and support my newborn at home. Holly's knowledge and guidance helped us understand what our baby needed and navigate the next steps in his care. I am so thankful for her knowledge, support and the confidence she gave us as parents.",
    author: "Judah's Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
  {
    quote:
      "Thrive has truly been a major help in our lives. We saw such a huge difference because of the therapy he received. What stood out most was the love shown to him and the genuine willingness to help our family.",
    author: "Nasir's Parent",
    service: "Physiotherapy & Feeding Therapy",
    accent: "sunny",
  },
  {
    quote:
      "Holly was instrumental in helping Sage meet her milestones. She was knowledgeable, encouraging, caring and supportive throughout our time at Thrive. Her expertise, commitment to our daughter's growth and willingness to collaborate with other physicians made us feel confident that we were choosing the best path forward.",
    author: "Sage's Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
  {
    quote:
      "Holly gave our son the skills and confidence to take his first steps, the ultimate freedom for a toddler. Her patience and care are unmatched. Watching him grow and progress was magical, and his face would light up whenever he saw her. She made therapy feel fun and effortless.",
    author: "A.'s Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
  {
    quote:
      "Physiotherapy has had such a positive impact on our daughter and our family. We have seen improvements in her strength, mobility, coordination and confidence. We also feel more informed, empowered and optimistic because we were given practical strategies to continue supporting her development at home.",
    author: "Desirae's Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
  {
    quote:
      "Thrive was exactly what we needed. Holly was incredibly supportive, professional and quickly learned our daughter's temperament and personality, which made such a difference in how successfully they worked together. The atmosphere was welcoming, comfortable and clean. Our entire experience was fantastic.",
    author: "Eloise's Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
  {
    quote:
      "After only a few sessions, I was given an exercise plan we could continue at home. We saw wonderful improvements in our daughter's mobility and confidence. I loved that she could continue progressing in the comfort of home, and I appreciated the welcoming atmosphere, patience, cleanliness and privacy at Thrive.",
    author: "Thrive Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
  {
    quote:
      "Thrive has changed her life completely. She is truly thriving. The professionalism of the team and the way they made her feel at home allowed her to feel comfortable, cooperate and get the most from her therapy.",
    author: "Amayah's Parent",
    service: "Occupational Therapy",
    accent: "leaf",
  },
  {
    quote:
      "Thrive helped my son regain strength following an illness. I loved how friendly and kind Holly was during his sessions. She celebrated every bit of progress and made sure I understood what we could continue working on at home.",
    author: "Mathias's Parent",
    service: "Physiotherapy & Feeding Therapy",
    accent: "sunny",
  },
];

export const SHORT_TESTIMONIALS = [
  {
    quote: "Thrive has boosted Najiyah's confidence. I loved how engaging and patient Holly was with my daughter.",
    author: "Najiyah's Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
  {
    quote: "We saw improvements every week and could not be more grateful. The experience was positive from the very beginning.",
    author: "Jrue's Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
  {
    quote: "Thrive helped Felicity increase her confidence after multiple surgeries. She was always excited before and even after her sessions.",
    author: "Felicity's Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
  {
    quote: "Holly gave us such a positive experience and helped our baby improve his strength and abilities in just a couple of months.",
    author: "Hector's Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
  {
    quote: "From 1 to 10, I would say 20. The experience was amazing.",
    author: "Ashwood's Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
  {
    quote: "My daughter showed progress instantly. She felt comfortable during her sessions and had great interaction.",
    author: "A.'s Parent",
    service: "Physiotherapy",
    accent: "teal",
  },
];

export const FAQS = [
  {
    question: "Do I need a referral?",
    answer:
      "No referral is needed to book. Parents know their children best! You can book an initial evaluation by contacting us or, for select services, through our online booking page. However, in order to use your health insurance, a medical referral from your child's pediatrician is required. See our Using Insurance page for the simple three-step process.",
  },
  {
    question: "How long are therapy sessions?",
    answer:
      "Initial evaluations typically last 45 to 60 minutes. Standard follow-up therapy sessions begin at 30 minutes, with longer sessions scheduled when appropriate based on your child's needs, goals and treatment plan. Your therapist will recommend the most appropriate session length and frequency for your child.",
  },
  {
    question: "Why are standard therapy sessions only 30 minutes?",
    answer:
      "When it comes to pediatric therapy, longer does not always mean better. Children learn best when they are engaged, regulated and actively participating. The American Academy of Pediatrics notes that younger children often do well with shorter therapy sessions because of their attention spans and that therapy dosage should be individualized based on each child's needs, goals, progress and response to treatment. At Thrive, 30 minutes is our standard starting point for follow-up sessions. When a child would benefit from additional treatment time or intensity, your therapist may recommend longer or more frequent sessions.",
    source:
      "Source: American Academy of Pediatrics, Prescribing Physical, Occupational, and Speech Therapy Services for Children With Disabilities.",
  },
  {
    question: "Do I have to stay with my child during appointments?",
    answer:
      "Children under 12 must be accompanied by a parent, legal guardian or authorized adult and may not be left unattended during therapy sessions, unless otherwise agreed upon in advance with your child's therapist. For older children, parent participation may vary depending on your child's age, needs and treatment goals. Your therapist may also invite you to join portions of the session to discuss progress, recommendations or strategies for home.",
  },
  {
    question: "How do I book an appointment?",
    answer:
      "You can book an appointment by contacting our team directly. Online booking is also available for select services through our Jane booking page. If you are unsure which service is right for your child, contact us and our team will help guide you toward the most appropriate place to start.",
  },
  {
    question: "Are you open on Saturdays?",
    answer:
      "No. Thrive is currently open Monday through Friday by appointment and does not offer regular Saturday appointments.",
  },
  {
    question: "How can I track my child's progress?",
    answer:
      "Your therapist will continually monitor your child's goals and response to treatment, with periodic progress reports provided to formally document progress, update goals and make recommendations for ongoing care. We also encourage ongoing communication with families so you understand what your child is working toward and how you can support those skills beyond the therapy room.",
  },
  {
    question: "What happens if I need to cancel an appointment?",
    answer:
      "We understand that plans change and children get sick. If you are unable to attend an appointment, please let us know as soon as possible so that we have the opportunity to offer that appointment time to another family. After three repeated cancellations within a reasonable period, Thrive reserves the right to charge a cancellation fee equal to 50% of the scheduled appointment fee. Cancellation fees are not billable to insurance.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "Thrive is a cashless practice. Payment may be made by credit or debit card, bank transfer, or secure online payment link. Payment is due at the time of service or by the invoice due date.",
  },
  {
    question: "What if my insurance does not cover the full cost of therapy?",
    answer:
      "Insurance coverage varies by provider and policy. Families are responsible for any fees not covered by their insurance plan, including deductibles, co-payments, co-insurance, denied claims and non-covered services. We recommend reviewing your therapy benefits before beginning treatment so you understand your individual coverage and financial responsibility.",
  },
  {
    question: "Where are you located?",
    answer:
      "Thrive is conveniently and centrally located at 11 Mount Royal Avenue (Hawkins Hill North), Nassau, The Bahamas. Our parking and entrance are at the REAR of the building. Use Google Maps to navigate directly to our clinic, or contact us for specific directions if you need a little help finding us. We know it can be tricky, so we're happy to guide you!",
    map: true,
  },
];

export const GALLERY = [
  { url: "https://images.pexels.com/photos/8422251/pexels-photo-8422251.jpeg?auto=compress&cs=tinysrgb&w=800", caption: "Playtime in our therapy gym" },
  { url: "https://images.unsplash.com/photo-1758598737547-666bce663667?auto=format&fit=crop&w=800&q=80", caption: "Building skills, block by block" },
  { url: "https://images.pexels.com/photos/19875334/pexels-photo-19875334.jpeg?auto=compress&cs=tinysrgb&w=800", caption: "Colorful adventures in the clinic" },
  { url: "https://images.pexels.com/photos/5275783/pexels-photo-5275783.jpeg?auto=compress&cs=tinysrgb&w=800", caption: "Movement is our superpower" },
  { url: "https://images.unsplash.com/photo-1685362158423-abf004b858d2?auto=format&fit=crop&w=800&q=80", caption: "Therapy through play" },
  { url: "https://images.unsplash.com/photo-1548289227-b7d966b70003?auto=format&fit=crop&w=800&q=80", caption: "Celebrating happy mealtimes" },
  { url: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&w=800&q=80", caption: "Little hands, big imagination" },
  { url: "https://images.unsplash.com/photo-1516627145497-ae6968895b74?auto=format&fit=crop&w=800&q=80", caption: "Growing confident communicators" },
  { url: "https://images.unsplash.com/photo-1472162072942-cd5147eb3902?auto=format&fit=crop&w=800&q=80", caption: "Friendship and fun in every session" },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Book an Evaluation",
    description:
      "Choose a time that suits your family by contacting us to book or booking online.",
  },
  {
    step: "02",
    title: "Initial Evaluation",
    description:
      "The first visit is all about getting to know your child: their strengths, needs, and your concerns through discussion, observation and play. We'll review our findings with you, establish a plan of care, and recommend the best next steps.",
  },
  {
    step: "03",
    title: "Follow-Up Sessions",
    description:
      "Follow-up sessions are your child's regular therapy sessions, focused on the needs identified during their evaluation and designed to build skills, make progress, and achieve their individual goals.",
  },
];
